import { render } from "./login.vue?vue&type=template&id=bb68bb70&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=bb68bb70&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb68bb70"]])

export default __exports__